
import { DocumentModalNames } from "./document.type.modal.name";
import DocumentTypeModalCreate from "../page/components/document.type.create";
import { DocumentTypeControllerState, DocumentTypeControllerAction } from "../controller/document.type.controller";
import DocumentTypeModalUpdate from "../page/components/document.type.update";

export interface DocumentTypeChild {
    name: DocumentModalNames;
    child: ({ ctrl }: { ctrl: DocumentTypeControllerState & DocumentTypeControllerAction }) => JSX.Element,
}
export const DocumentTypeChildrenData: DocumentTypeChild[] = [
    {
        name: DocumentModalNames.CREATE,
        child: ({ ctrl }: { ctrl: DocumentTypeControllerState & DocumentTypeControllerAction }) => <DocumentTypeModalCreate ctrl={ctrl} />,
    },
    {
        name: DocumentModalNames.UPDATE,
        child: ({ ctrl }: { ctrl: DocumentTypeControllerState & DocumentTypeControllerAction }) => <DocumentTypeModalUpdate ctrl={ctrl} />,
    }
]